import React from 'react';
import { CopyButton } from './CopyButton';
import { PrintButton } from './PrintButton';

import * as S from './styles';

export const InvoiceActions = ({ dataBilling, pdfUrl, pdfLoading, pdfError, ...props }) => (
  <>
    <S.ButtonContainer {...props}>
      {dataBilling.invoiceStatus === 'Pending' && (
        <CopyButton code={dataBilling.invoiceBarCode} />
      )}
      <PrintButton 
        className='print-button' 
        dataBilling={dataBilling} 
        pdfUrl={pdfUrl}
        pdfLoading={pdfLoading}
        pdfError={pdfError}
      />
    </S.ButtonContainer>
  </>
);
